import { useState, useEffect, useCallback, useId } from 'react';
import classNames from 'classnames';

import { useLocation } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { API, Storage, Auth } from 'aws-amplify';

import { styles } from './util';
import { LdsSpinner } from '../../Util/LoadingIcons';
import CLOUDFRONT_CONFIG from '../../../config/cloudfront.json';

const styling = makeStyles(styles());
const MODEL = 'STREAM_LATL';

export const Results = () => {
    const [requestId, setRequestId] = useState(null);
    const [requestIdsList, setRequestIdsList] = useState([]);
    const [privatePrefix, setPrivatePrefix] = useState('/LearnAtLunch_Recordings_KEEP/');
    const classes = styling();
    
    function handleInputChange(e) {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        if (name === 'requestId'){
            setRequestId(value);
        }
    }

    // Initial setup
    useEffect(() => {
         // Load requests
        getRequests();
        getCookie();
        // 
    }, []);

    const getRequests = useCallback(async () => {
        const options = {
            headers: {},
            response: true,
            queryStringParameters: {
                requestType: MODEL,
                callType: 'videos',
            }
        };

        try {
            const response = await API.get("AQcast", "/request", options)
            if (response.status >= 200 && response.status <= 299) {
                const data = response.data;
                const requests = data.requestIds;

                setRequestIdsList(requests);

            } else {
                console.log('Bad response fetching requests');
            }
        } catch(err) {
            console.log(`Error fetching ${MODEL} requests`);
            console.log(err);
        }
    }, [requestId]);

    const getCookie = useCallback(async () => {
        const options = {
            headers: {},
            response: true,
            queryStringParameters: {
                requestType: MODEL,
                callType: 'cookie',
            }
        };

        try {
            const response = await API.get("AQcast", "/request", options)
            if (response.status >= 200 && response.status <= 299) {
                const data = response.data;
                const requests = data.cookies;
                document.cookie = `CloudFront-Key-Pair-Id=${requests['CloudFront-Key-Pair-Id']}; path=${privatePrefix}; samesite=none; secure`;
                document.cookie = `CloudFront-Signature=${requests['CloudFront-Signature']}; path=${privatePrefix}; samesite=none; secure`;
                document.cookie = `CloudFront-Policy=${requests['CloudFront-Policy']}; path=${privatePrefix}; samesite=none; secure`;
                console.log("cookies set")
            } else {
                console.log('Bad response fetching cookie');
            }
        } catch(err) {
            console.log(`Error fetching ${MODEL} cookie`);
            console.log(err);
        }
    });    

    const JobInfo = () => {
        if (requestId === null && requestIdsList === null) {
            return <LdsSpinner/>
        } else if (!requestIdsList.length) {
            return <h3 style={{textAlign: 'center'}}>Thinking ....</h3>
        } else {
            return (
                <div style={{width: '100%', float: 'center'}}>
                    <b> Select Video to Stream: </b>

                    <TextField
                        className={classNames(classes.margin, classes.textField)}
                        select
                        style={{maxWidth: '445px'}}
                        name="requestId"
                        value={requestId}
                        onClick={() => getRequests()}
                        onChange={handleInputChange}>
                        
                        {requestIdsList.map(reqId => (
                            <MenuItem key={useId()} value={reqId.key}>
                                {reqId.file_name}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
            )
        }
    }

    function format_url(key) {
        if (key !== null){
            console.log(`https://${CLOUDFRONT_CONFIG.DOMAIN}/${key}`)
            return `https://${CLOUDFRONT_CONFIG.DOMAIN}/${key}`

        } else {
            console.log("Select a video to play.")
            return 
        }        
    }

    return (
        <div >
            <div style={{textAlign: 'center', width: '100%'}}>
                <h1>  </h1>
                <JobInfo />

                <h3>Video:</h3>
                { requestId && <video width='85%' height='85%' controls key={requestId}>
                    <source src={format_url(requestId)} type="video/mp4" />
                </video>
                }

            </div>
        </div>
    )
}

export default Results;